import { BigNumber } from "ethers";
import { getTokenAddress } from "../config/tokens";
import { getDcaPoolContractAddr, getDcaPoolContracts, getDcaPoolIdx } from "../config/resolver";
import { getFramework } from "./sf";

async function getStream(provider, chainId, account, srcToken, tgtToken) {
  const sf = await getFramework(provider, chainId);
  let srcTokenAddr = getTokenAddress(chainId, srcToken);
  let contractAddr = getDcaPoolContractAddr(chainId, srcToken, tgtToken);

  return await sf.cfaV1.getFlow({
    superToken: srcTokenAddr,
    sender: account,
    receiver: contractAddr,
    providerOrSigner: provider,
  });
}

async function getStreams(provider, chainId, account) {
  const sf = await getFramework(provider, chainId);
  let pairsAddrs = Object.entries(getDcaPoolContracts(chainId));
  let streams = [];

  for (let i in pairsAddrs) {
    let [tgtToken, srcTokens] = pairsAddrs[i];
    srcTokens = Object.entries(srcTokens);

    for (let j in srcTokens) {
      let srcToken = srcTokens[j][0];
      let srcTokenAddr = getTokenAddress(chainId, srcToken);
      let contractAddr = srcTokens[j][1].contractAddress;

      let flow = await sf.cfaV1.getFlow({
        superToken: srcTokenAddr,
        sender: account,
        receiver: contractAddr,
        providerOrSigner: provider,
      });
      flow.flowRate = BigNumber.from(flow.flowRate);
      flow.deposit = BigNumber.from(flow.deposit);
      flow.owedDeposit = BigNumber.from(flow.owedDeposit);
      flow.sourceToken = srcToken;
      flow.targetToken = tgtToken;
      flow.contractAddress = contractAddr;

      streams.push(flow);
    }
  }

  return streams;
}

async function getClaims(provider, chainId, account) {
  const sf = await getFramework(provider, chainId);
  let pairsAddrs = Object.entries(getDcaPoolContracts(chainId));
  let claims = [];

  for (let i in pairsAddrs) {
    let [tgtToken, srcTokens] = pairsAddrs[i];
    let tgtTokenAddr = getTokenAddress(chainId, tgtToken);
    srcTokens = Object.entries(srcTokens);

    for (let j in srcTokens) {
      let srcToken = srcTokens[j][0];
      let contractAddr = srcTokens[j][1].contractAddress;

      const idx = getDcaPoolIdx(chainId, srcToken, tgtToken);
      const subscription = await sf.idaV1.getSubscription({
        publisher: contractAddr,
        indexId: idx,
        superToken: tgtTokenAddr,
        subscriber: account,
        providerOrSigner: provider,
      });

      subscription.pairContractAddress = contractAddr;
      subscription.indexId = idx;
      subscription.sourceToken = srcToken;
      subscription.targetToken = tgtToken;
      // subscription.pendingDistribution = BigNumber.from(subscription.pendingDistribution);
      // subscription.units = BigNumber.from(subscription.units);

      claims.push(subscription);
    }
  }

  return claims;
}

async function approveSubscription(provider, chainId, pairContractAddr, targetToken, idx) {
  const sf = await getFramework(provider, chainId);

  let targetTokenAddr = getTokenAddress(chainId, targetToken);

  try {
    const subscriptionApprovalOp = await sf.idaV1.approveSubscription({
      indexId: idx,
      superToken: targetTokenAddr,
      publisher: pairContractAddr,
    });

    const result = await subscriptionApprovalOp.exec(provider);

    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export { getStream, getStreams, getClaims, approveSubscription };
